import { all } from 'redux-saga/effects'

import { applicationsSaga } from './applications/sagas'

export function* candidatesSaga() {
  yield all([applicationsSaga()])
}
